import React, { useState, useEffect } from "react";
import "./styles.css"
import { Affix, Row, Col } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { AnnouncementBar } from "../../UIcomponents/UiComponents";
import { useDispatch } from "react-redux";
import HamMenu from "./HamMenu";
import { getAboutInfo } from "../../../store/features/about/aboutActions";
import LocalizationContext from "../../../localization/LocalizationContext";
import CookieStorageNotification from "../cookiestoragenotification/CookieStorageNotification";
import MainLogo from "../icons/MainLogo";
import useScrollHideHeader from "../../../utils/useScrollHeader";

export default function MainNavBar(props) {
  const { t, i18n } = React.useContext(LocalizationContext);
  const appLanguage = i18n.language;

  const dispatch = useDispatch();
  let [mainNavOffset, setMainNavOffset] = useState(0);
  useScrollHideHeader(["main-nav-container"]);

  useEffect(() => {
    if (appLanguage) {
      dispatch(getAboutInfo(appLanguage));
    } else {
      dispatch(getAboutInfo("en"));
    }
  }, [appLanguage]);

  const setStateOfCookieMessage = (val) => {
    sessionStorage.setItem("cookieMessageDisplayed", val);
  };
  const setStateOfAnnouncementMessage = (val) => {
    sessionStorage.setItem("announcementMessageDisplayed", val);
  };

  let stateOfAnnouncementMessage = sessionStorage.getItem(
    "announcementMessageDisplayed"
  );
  let stateOfCookieMessage = sessionStorage.getItem("cookieMessageDisplayed");

  return (
    <>
      {/* render them based on values of session  storage  to make sure they are no  re-rendered on  every  refresh  */}
      {!stateOfCookieMessage && (
        <CookieStorageNotification
          setStateOfCookieMessage={setStateOfCookieMessage}
        />
      )}
      {!stateOfAnnouncementMessage && (
        <AnnouncementBar
          setStateOfAnnouncementMessage={setStateOfAnnouncementMessage}
        />
      )}
      <Affix
        offsetTop={mainNavOffset}
      // onChange={(e) => {
      //   if (e) {
      //     setMainNavOffset(200);
      //   }
      //   console.log("change", e);
      // }}
      >
        <div
          id="main-nav-container"
          className={
            props.bgClass
              ? `${props.bgClass} content-container-wrapper`
              : "content-container-wrapper"
          }
        >
          <div className="content-container-content text-fabric-serif">
            <div className="mainnavbar__container">
              <Row>
                <div style={{ flex: "1", display: "flex", flexDirection: "row" }} >
                <Link to="/">
                  <div className="mainnavbar__page-title text-fabric-sans desktopOnly">
                    HORDALAND KUNSTSENTER
                  </div>
                    <div className="mainnavbar__page-title text-fabric-sans mobileOnly">
                      HKS
                    </div>
                  </Link>
                  <div style={{ flex: "1", display: "flex", justifyContent: "center" }}>
                    <Link to="/">
                      <MainLogo />
                    </Link>
                  </div>

                </div>



                <Col
                  xs={{ span: 2, order: 2 }}
                  sm={{ span: 2, order: 2 }}
                  md={{ span: 2, order: 2 }}
                  lg={{ span: 2, order: 3 }}
                  xl={{ span: 2, order: 3 }}
                  xxl={{ span: 2, order: 3 }}
                >
                  <div className="mainnavbar__ham-menu-icon flex-row-justify-flex-end fs-1-6em lh-1-4em">
                    {
                      <MenuOutlined
                        className="openbtn"
                        onClick={() => {
                          window.openNav();
                        }}
                      />
                    }
                  </div>
                </Col>
              </Row>
            </div>

          </div>

        </div>
      </Affix>
      <HamMenu />
    </>
  );
}
